// extracted by mini-css-extract-plugin
export default {"token":"Users_token__VMnmJ"};